
<template>
    <div id="data-list-list-view" class="data-list-container">
  
      <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="brokerCommissions">
  
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
  
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ brokerCommissions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : brokerCommissions.length }} of {{ brokerCommissions.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
  
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
  
        <template slot="thead">
          <vs-th sort-key=""></vs-th>
          <vs-th sort-key="brokerName">Broker Name</vs-th>
          <vs-th sort-key="promoCodeName">Promo Code Name</vs-th>
          <vs-th sort-key="promoCodeCommissionPercent">Promo Code Commission Percent %</vs-th>
          <vs-th sort-key="priceBeforeDiscount">Guest Base Rate (USD)</vs-th>
          <vs-th sort-key="commission">Broker Commission (USD)</vs-th>
          <vs-th sort-key="exchangeRate">Exchange Rate</vs-th>
          <vs-th sort-key="commissionEGP">Broker Commission (EGP)</vs-th>
          <vs-th sort-key="guestBookingDate">Guest Booking Date</vs-th>
          <vs-th sort-key="guestName">Guest Name</vs-th>
          <vs-th sort-key="propertyNickName">Property Name</vs-th>
          <vs-th sort-key="reservationID">Reservation Id</vs-th>
          <vs-th sort-key="check_in">Check In</vs-th>
          <vs-th sort-key="check_out">Check Out</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-avatar v-if="tr.brokerImage" size="large" :src="tr.brokerImage" />
              <vs-avatar v-else size="large" src="https://lemonspaces.com/frontend/images/broker.png"  style="background:#FFFFFF;"/>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.brokerName}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.promoCodeName}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.promoCodeCommissionPercent}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.priceBeforeDiscount}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.commission}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.exchangeRate}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.commissionEGP}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold" style="width: 80px;">{{tr.guestBookingDate}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.guestName}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold" style="width: 150px;">{{tr.propertyNickName}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold">{{tr.reservationID}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold" style="width: 80px;">{{tr.check_in}}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-bold" style="width: 80px;">{{tr.check_out}}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </template>
  
  <script>
    import {mapGetters, mapActions} from 'vuex'
  
    export default {
      data() {
        return {
          itemsPerPage: 5,
          isMounted: false,
          stats: {},
          profileData: {}
        }
      },
      async created() {
        this.$vs.loading({ text: 'Loading All Brokers Commissions' })
        await this.loadAllBrokerCommissions({
          storeName: 'brokerCommissions',
          url: `admin/brokers/get-commissions`,
          commitUrl: 'brokerCommissions/SET_BROKER_COMMISSIONS',
        })
        console.log(this.brokerCommissions)
        this.$vs.loading.close()
      },
      computed: {
        ...mapGetters({
          brokerCommissions: 'brokerCommissions/brokerCommissionsList',
          isLoading: 'brokerCommissions/isLoading',
          error: 'brokerCommissions/error',
        }),
        currentPage() {
          if(this.isMounted) {
            return this.$refs.table.currentx
          }
          return 0
        },
      },
      methods: {
        ...mapActions({
          loadAllBrokerCommissions: 'get',
          deleteBroker: 'delete',
        }),
        errorNotify(){
          this.$vs.notify({color:'danger', title:'Error', text:this.error})
        },
        deleteRow(id) {
        },
        editRow(brokerID) {

        }
      },
      watch: {
        isLoading(newValue) {
          if (newValue) {
            this.$vs.loading()
          }else {
            this.$vs.loading.close()
          }
        },
        error(newValue) {
          if (newValue != null) {
            this.errorNotify()
          }
        }
      },
      mounted() {
        this.isMounted = true;
      }
    }
  </script>
  
  <style lang="scss">
    #data-list-list-view {
      .vs-con-table {
  
        .vs-table--header {
          display: flex;
          flex-wrap: wrap-reverse;
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          > span {
            display: flex;
            flex-grow: 1;
          }
  
          .vs-table--search{
            padding-top: 0;
  
            .vs-table--search-input {
              padding: 0.9rem 2.5rem;
              font-size: 1rem;
  
              &+i {
                left: 1rem;
              }
  
              &:focus+i {
                left: 1rem;
              }
            }
          }
        }
  
        .vs-table {
          border-collapse: separate;
          border-spacing: 0 1.3rem;
          padding: 0 1rem;
  
          tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 8px 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
          }
        }
  
        .vs-table--thead{
          th {
            padding-top: 0;
            padding-bottom: 0;
  
            .vs-table-text{
              text-transform: uppercase;
              font-weight: 600;
            }
          }
          th.td-check{
            padding: 0 15px !important;
          }
          tr{
            background: none;
            box-shadow: none;
          }
        }
  
        .vs-table--pagination {
          justify-content: center;
        }
      }
    }
  </style>
  